import { useState } from "react";
import Eyebrow from "../components/Eyebrow";
import SkillCard from "../components/SkillCard";

const CODING_SKILLS = [
  { icon: "monitor", title: "Frontend Development", description: "I bring ideas to life in the browser, coding from scratch." },
  { icon: "code", title: "Backend Development", description: "Building powerful server-side systems, coding from scratch." },
  { icon: "squares", title: "Web Applications", description: "Creating dynamic and intuitive web experiences." },
  { icon: "cog", title: "API Development", description: "Crafting robust APIs, turning ideas into functional solutions." },
  { icon: "phone", title: "Mobile Applications", description: "Developing mobile apps with seamless user experiences." },
];

const SOFT_SKILLS = [
  { icon: "chat", title: "Communication", description: "Effective exchange of information and ideas." },
  { icon: "users", title: "Collaboration", description: "Working effectively in a team environment." },
  { icon: "arrows", title: "Adaptability", description: "Flexibility to embrace change and new technologies." },
  { icon: "clock", title: "Time Management", description: "Efficiently organizing and prioritizing tasks." },
  { icon: "cog", title: "Problem Solving", description: "Analytical thinking to resolve challenges." },
  { icon: "bulb", title: "Creativity", description: "Generating innovative solutions and ideas." },
];

export default function About() {
  const [tab, setTab] = useState<"coding" | "soft">("coding");
  const skills = tab === "coding" ? CODING_SKILLS : SOFT_SKILLS;

  return (
    <section className="about">
      <div className="about-intro">
        <Eyebrow>ABOUT&nbsp;ME</Eyebrow>
        <h2 className="about-statement">
          A developer who <span className="hl">sweats the details</span> — building
          products end&#8209;to&#8209;end, from the database to the last pixel.
        </h2>
        <div className="about-cols">
          <p>
            I'm an experienced Full-Stack Developer with a passion for crafting
            visually appealing and user-friendly products. My expertise spans
            front-end and back-end development, and I stay up-to-date with industry
            trends to continuously deliver high-quality solutions.
          </p>
          <p>
            Currently I work at{" "}
            <a className="link" href="https://cakedidit.com/" target="_blank" rel="noreferrer">
              Cake Didit
            </a>
            , specializing in web development, mobile applications and IT solutions —
            collaborating closely with a passionate team on cutting-edge projects.
          </p>
        </div>
        <ul className="about-meta">
          <li>
            <span className="meta-k">Based in</span>
            <span className="meta-v">Montevideo, UY</span>
          </li>
          <li>
            <span className="meta-k">Focus</span>
            <span className="meta-v">Web · Mobile · APIs</span>
          </li>
          <li>
            <span className="meta-k">Currently</span>
            <span className="meta-v">
              <a className="link" href="https://cakedidit.com/" target="_blank" rel="noreferrer">
                @ Cake Didit
              </a>
            </span>
          </li>
        </ul>
      </div>

      <div className="about-block">
        <div className="skills-head">
          <Eyebrow>OTHER&nbsp;SKILLS</Eyebrow>
          <div className="seg">
            <button
              className={`seg-btn ${tab === "coding" ? "on" : ""}`}
              onClick={() => setTab("coding")}
            >
              Coding
            </button>
            <button
              className={`seg-btn ${tab === "soft" ? "on" : ""}`}
              onClick={() => setTab("soft")}
            >
              Soft skills
            </button>
          </div>
        </div>

        {/* Keyed by tab so the cards remount and replay their CSS reveal on switch. */}
        <div className="skills-grid" key={tab}>
          {skills.map((s, i) => (
            <SkillCard key={i} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}
